"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFileDropZoneStyles = exports.columnMapperStyles = exports.dataUploadModalStyles = void 0;
const createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
const makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
const utils_1 = require("../../utils");
const constants_1 = require("./constants");
exports.dataUploadModalStyles = (theme) => createStyles_1.default({
    dialogTitle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'row',
        backgroundColor: theme.palette.common.white,
    },
    closeButton: {
        padding: 0,
        color: theme.palette.black.light,
    },
    dialogActions: {
        '&.MuiDialogActions-root': {
            padding: '0.5rem 1.5rem',
        },
    },
});
exports.columnMapperStyles = (theme) => createStyles_1.default({
    columnMapperContainer: {
        height: '100%',
        width: '100%',
        position: 'relative',
    },
    columnMapperHeader: {
        height: '3.5rem',
        backgroundColor: theme.palette.offWhite,
        borderTop: '0.0625rem solid ' + theme.palette.black['600'],
        borderBottom: '0.0625rem solid ' + theme.palette.black['600'],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-evenly',
    },
    columnMapperHeaderCell: {
        borderRight: '0.0625rem solid ' + theme.palette.black['600'],
    },
});
exports.useFileDropZoneStyles = {
    [constants_1.FileDropZoneStyle.PRIMARY]: makeStyles_1.default((theme) => ({
        dropzoneContainer: {
            height: '17.25rem',
            backgroundColor: theme.palette.black['600'],
            border: `0.0625rem dashed ${theme.palette.black.light}`,
            borderRadius: '0.25rem',
        },
        dropzoneInnerContainer: {
            margin: '0 auto',
            height: '100%',
        },
        dropzoneContent: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '100%',
        },
        dropzoneContentBar: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        dropzoneTitle: {},
        dropzoneButton: {},
        acceptedTypes: {},
    })),
    [constants_1.FileDropZoneStyle.SECONDARY]: makeStyles_1.default((theme) => ({
        dropzoneContainer: {
            backgroundColor: theme.palette.black['600'],
            border: `0.0625rem dashed ${theme.palette.black.light}`,
            borderRadius: '0.25rem',
        },
        dropzoneInnerContainer: {
            margin: '0 auto',
            height: '100%',
        },
        dropzoneContent: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '100%',
        },
        dropzoneContentBar: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        dropzoneTitle: {
            fontSize: utils_1.pxToRem('14'),
            padding: '0.75rem 0',
        },
        dropzoneButton: {
            height: utils_1.pxToRem('24'),
        },
        acceptedTypes: {
            padding: '0.75rem 0',
        },
    })),
};
//# sourceMappingURL=data:application/json;base64,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